import { render, staticRenderFns } from "./CertificateDesigner.vue?vue&type=template&id=007f688a&scoped=true&"
import script from "./CertificateDesigner.vue?vue&type=script&lang=js&"
export * from "./CertificateDesigner.vue?vue&type=script&lang=js&"
import style0 from "./CertificateDesigner.vue?vue&type=style&index=0&id=007f688a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007f688a",
  null
  
)

export default component.exports